import React from 'react';

const Favorite = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.33203 4.16587C3.33203 2.78541 4.45112 1.66632 5.83158 1.66632H14.1634C15.5439 1.66632 16.663 2.78541 16.663 4.16587V17.2433C16.663 17.8977 15.9431 18.2967 15.3882 17.9498L10.4391 14.8566C10.1689 14.6878 9.82608 14.6878 9.55591 14.8566L4.6068 17.9498C4.05186 18.2967 3.33203 17.8977 3.33203 17.2433V4.16587Z",
      stroke: "white",
      strokeWidth: "1.24977"
    }
  )
);

export { Favorite };
//# sourceMappingURL=Favorite.js.map
